var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.33333C9.838 1.33333 11.3333 2.82867 11.3333 4.66733C11.3333 6.50467 9.838 8.00067 8 8.00067C6.162 8.00067 4.66667 6.50467 4.66667 4.66733C4.66667 2.82867 6.162 1.33333 8 1.33333ZM8 0C5.42267 0 3.33333 2.08933 3.33333 4.66733C3.33333 7.244 5.42267 9.334 8 9.334C10.5773 9.334 12.6667 7.244 12.6667 4.66733C12.6667 2.08933 10.5773 0 8 0V0ZM12.246 8.902C11.9147 9.234 11.5413 9.52267 11.1407 9.77C13.0553 11.0193 14.0593 13.1587 14.4553 14.6673H1.53067C1.912 13.1407 2.90267 10.9987 4.846 9.762C4.444 9.51267 4.07133 9.22133 3.74067 8.88733C0.902 10.9353 0 14.558 0 16H16C16 14.572 15.04 10.962 12.246 8.902Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.a4b4282b.svg";
export { ForwardRef as ReactComponent };